import { useGlobalStoreActions } from '../../store/globalStore'
import { ISnackbarMessageSeverity } from './MySnackbarIntefaces'

export const useSnackbarComponent = () => {
  const setSnackbarMessage = useGlobalStoreActions(
    actions => actions.setSnackbarMessage,
  )
  const setSnackbarMessageSeverity = useGlobalStoreActions(
    actions => actions.setSnackbarMessageSeverity,
  )

  function openSnackbar(
    message: string,
    messageSeverity: ISnackbarMessageSeverity,
  ) {
    setSnackbarMessageSeverity(messageSeverity)
    setSnackbarMessage(message)
  }

  return {
    open: openSnackbar,
  }
}
